import script from "./CreateOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateOffer.vue?vue&type=script&setup=true&lang=js"

import "./CreateOffer.vue?vue&type=style&index=0&id=01ae4384&lang=css"

const __exports__ = script;

export default __exports__